import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Reemplaza al veterinario?',
  answer: 'No. Es una guía para actuar en los primeros minutos mientras contactás al profesional.'
}, {
  question: '¿Sirve para perros y gatos?',
  answer: 'Sí. Incluye diferencias específicas entre ambos.'
}, {
  question: '¿En qué formato viene?',
  answer: 'Formato PDF descargable compatible con celular, tablet y computadora.'
}, {
  question: '¿Recibo acceso inmediato?',
  answer: 'Sí. Una vez realizada la compra podés descargarlo al instante.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-white py-16 px-4" data-id="element-54">
      <div className="max-w-3xl mx-auto" data-id="element-55">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 text-[#111827]" data-id="element-56">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-57">
          {faqs.map((faq, i) => <div key={i} className="border border-gray-200 rounded-xl overflow-hidden transition-all duration-200 hover:border-blue-200 hover:shadow-sm" data-id="element-58">
              <button onClick={() => toggle(i)} className="w-full flex items-center justify-between px-6 py-5 text-left bg-white hover:bg-gray-50 transition-colors" data-id="element-59">
                <span className="text-[#111827] font-bold text-lg pr-4" data-id="element-60">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-blue-600 flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-61" />
              </button>
              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === i ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-62">
                <p className="px-6 pb-6 text-[#4B5563] text-base leading-relaxed" data-id="element-63">
                  {faq.answer}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}